.filtersContainer {
  display: flex;
  justify-items: flex-start;
  align-items: center;

  width: 100%;
  padding: 12px 16px;
  margin: 0 auto;

  /**
	 * This will ensure that the filters can still scroll horizontally, while
	 * the scrollbar remains hidden.
 	 */
  overflow-x: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* for Chrome, Safari and Opera */
  }

  @media (min-width: 768px) {
    /* show horizontal scroll bar on desktop */
    -ms-overflow-style: unset; /* IE and Edge */
    scrollbar-width: unset; /* Firefox */

    &::-webkit-scrollbar {
      display: unset; /* for Chrome, Safari and Opera */
    }
  }

  @media (min-width: 1024px) {
    width: calc(100% - 32px);

    &.oc {
      padding: 30px 0px 20px 0px;
    }

    &.default {
      padding: 21px 0px 16px 0px;
    }
  }

  &.oc {
  }

  &.default {
    background-color: var(--ogm-white);
    margin-bottom: 16px;

    @media (min-width: 1024px) {
      background-color: transparent;
    }
  }

  .filter {
    margin-right: 15px;
    padding: 0px 12px;
    line-height: 30px;
    border: 1px solid;
    border-radius: 15px;
    cursor: pointer;
    font-family: var(--ogm-font-family-2);

    letter-spacing: 0.5px;

    white-space: nowrap;

    &.oc {
      font-size: 14px;
      font-weight: 500;
      background-color: var(--ogm-bg-grey);
      border-color: var(--ogm-border-grey);
      color: var(--ogm-black);

      @media (min-width: 1024px) {
        font-size: 14px;
        font-weight: 600;
      }
    }

    &.default {
      font-size: 14px;
      font-weight: 600;
      background-color: transparent;
      border-color: var(--ogm-grizzlies);
      color: var(--ogm-timberwolves);

      @media (min-width: 1024px) {
        font-size: 15px;
        /* font-weight: 500; */
      }
    }

    &.active {
      border-color: transparent;

      &.oc {
        background-color: var(--ogm-active-tab-bg-color);
        color: var(--ogm-white);
      }

      &.default {
        background-color: var(--ogm-seahawks);
      }
    }
  }
}
